define.alias("shared/components/shared/addon-details-card/current-plan", "settings/components/shared/addon-details-card/current-plan");